
import  React from 'react';
import { Icon,notification } from 'tea-component';

// 下载提示 success error loading
export const downDataTip = (type, title) => {

  if (type === 'error') {
    return notification.error({
      className: `downDataBox downData${  type}`,
      description: title,
      duration: 5000
    });
  }

  const loadingIcon = <>
    {type==='loading'&& <Icon size="l" type="loading" className="loading-icon" />}
    {title}
  </>;

  return notification.success({
    className: `downDataBox downData${  type}`,
    description: loadingIcon,
    duration: type==='loading' ? 0 : 5000
  });
};
